<template>
    <div class="page-main">
        <div class="spaceBetween">
            <page-title />
            <div class="spaceRight op-btn">
                <el-button @click="goBack">
                    <i class="el-icon-arrow-left"></i>
                    <span>Back</span>
                </el-button>
            </div>
        </div>

        <div class="detail-header" v-loading="loading">
            <div class="detail-title">{{ planData.planName }} Details</div>
            <div class="detail-info">
                <el-row :gutter="20">
                    <el-col :span="8">
                        <div class="info-item">
                            <div class="label">Planned release:</div>
                            <div class="value">{{ planData.planAmount }}
                                <span class="unit">(Release Percentage: {{ releasePercentage }}%)</span>
                            </div>

                        </div>
                    </el-col>


                    <el-col :span="8">
                        <div class="info-item">
                            <div class="label">Claim Method:</div>
                            <div class="value">{{ getClaimMethodText(planData.claimMethod) }}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="info-item">
                            <div class="label">Unlock frequency:</div>
                            <div class="value">{{ getUnlockFrequencyText(planData.unlockFrequency) }}</div>
                        </div>
                    </el-col>
                    <el-col v-if="planData.unlockFrequency === 1" :span="8">
                        <div class="info-item">
                            <div class="label">Distribution Frequency:</div>
                            <div class="value">{{ planData.distributionFrequency }} Day</div>
                        </div>
                    </el-col>


                    <el-col v-if="planData.unlockFrequency === 1" :span="8">
                        <div class="info-item">
                            <div class="label">Lockup Period:</div>
                            <div class="value">{{ planData.unlockPeriod }} Day</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="info-item">
                            <div class="label">Unlock date(UTC time):</div>
                            <div class="value">{{ formatDate(planData.unlockDate * 1000) }}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="info-item">
                            <div class="label">Unlock date(China time):</div>
                            <div class="value">{{ formatDateChina(planData.unlockDate * 1000) }}</div>
                        </div>
                    </el-col>
                    <el-col :span="8">
                        <div class="info-item">
                            <div class="label">Status:</div>
                            <div class="value" :class="getStatusClass(planData.status)">{{
                                getStatusText(planData.status) }}
                            </div>
                        </div>
                    </el-col>


                    <el-col v-if="planData.unlockFrequency === 0" :span="8">
                        <div class="info-item">
                            <div class="label">Successfully Transferred:</div>
                            <div class="value">{{ planData.totalAmounts[1] }} UNIT</div>
                        </div>
                    </el-col>
                    <el-col v-if="planData.unlockFrequency === 0" :span="8">
                        <div class="info-item">
                            <div class="label">Pending Transfers:</div>
                            <div class="value">{{ planData.totalAmounts[0] }} UNIT</div>
                        </div>
                    </el-col>


                    <el-col v-if="planData.unlockFrequency === 1" :span="8">
                        <div class="info-item">
                            <div class="label">Claimed:</div>
                            <div class="value"> {{ planData.totalAmounts[1] }} UNIT</div>
                        </div>
                    </el-col>
                    <el-col v-if="planData.unlockFrequency === 1" :span="8">
                        <div class="info-item">
                            <div class="label">Remaining:</div>
                            <div class="value"> {{ planData.totalAmounts[0] }} UNIT</div>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>

        <!-- Single类型的白名单列表 -->
        <page-card title="Whitelist" class="no-padding" v-if="planData.unlockFrequency === 0">
            <div slot="body" class="page-table" v-loading="accountsLoading">
                <div class="table_box">
                    <el-table :data="accountsData">
                        <el-table-column type="index" width="55"></el-table-column>
                        <el-table-column prop="account" label="Address"></el-table-column>
                        <el-table-column prop="amount" label="Amount of Tokens">
                            <template slot-scope="{row}">
                                {{ row.amount * row.times }} UNIT
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="Status">
                            <template slot-scope="{row}">
                                <span :class="getRecordStatusClass(row.status)">
                                    {{ getRecordStatusText(row.status) }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="first" label="Unlock date">
                            <template slot-scope="{row}">
                                <div>
                                    {{ formatDate(row.first * 1000) }}(UTC)
                                </div>
                                <div> {{ formatDateChina(row.first * 1000) }}(China)</div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="pagination-container">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="pagination.page" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
                    </el-pagination>
                </div>
            </div>
        </page-card>

        <!-- Liner类型的白名单列表 -->
        <page-card title="Whitelist" class="no-padding" v-if="planData.unlockFrequency === 1">
            <div slot="body" class="page-table" v-loading="accountsLoading">
                <div class="table_box">
                    <el-table :data="accountsData">
                        <el-table-column type="index" width="55"></el-table-column>
                        <el-table-column prop="account" label="Address"></el-table-column>
                        <el-table-column prop="amount" label="Amount of Tokens">
                            <template slot-scope="{row}">
                                {{ row.amount * row.times }} UNIT
                            </template>
                        </el-table-column>
                        <el-table-column prop="first" label="Start date">
                            <template slot-scope="{row}">
                               <div> {{ formatDate(row.first * 1000) }}(UTC)</div>
                               <div> {{ formatDateChina(row.first * 1000) }}(China)</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="last" label="Fully unlocked date">
                            <template slot-scope="{row}">
                                <div> {{ formatDate(row.last * 1000) }}(UTC)</div>
                                <div> {{ formatDateChina(row.last * 1000) }}(China)</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="times" label="Unlock times"></el-table-column>
                        <el-table-column prop="per" label="Amount per unlock">
                            <template slot-scope="{row}">
                                <!-- {{ calculatePerAmount(row) }} UNIT -->
                                {{ row.amount }} UNIT
                            </template>
                        </el-table-column>
                        <el-table-column prop="claimed" label="Total claimed tokens">
                            <template slot-scope="{row}">
                                {{ row.amounts[1] }} UNIT
                            </template>
                        </el-table-column>
                        <el-table-column prop="remaining" label="Remaining tokens">
                            <template slot-scope="{row}">
                                {{ row.amounts[0] }} UNIT
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <div class="pagination-container">
                    <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                        :current-page="pagination.page" :page-sizes="[10, 20, 30, 50]" :page-size="pagination.pageSize"
                        layout="total, sizes, prev, pager, next, jumper" :total="pagination.total">
                    </el-pagination>
                </div>
            </div>
        </page-card>
        <ErrorMsg ref="ErrorMsg"></ErrorMsg>
    </div>
</template>

<script>
import { getPlanDetail, getLockedRecords } from '@/api/tokenlocker'
import moment from 'moment'
import Web3 from 'web3'
import { getAbi } from '@/api/file'

export default {
    data() {
        return {
            releasePercentage: 0,
            planID: '',
            loading: false,
            accountsLoading: false,
            contractAddress: '',
            TokenLockerAbi: [],
            planData: {
                planID: 'keccak256ID',
                planName: 'testplan',
                planAmount: 100000,
                claimMethod: 1,
                unlockFrequency: 0,
                distributionFrequency: 1,
                unlockPeriod: 1,
                unlockDate: 1744013462469,
                status: 0,
                accounts: [],
                totalAmounts: [0, 0]
            },
            accountsData: [],
            pagination: {
                page: 1,
                pageSize: 20,
                total: 0
            }
        }
    },
    async created() {
        // 从路由参数获取planID
        this.planID = this.$route.params.id
        // 获取ABI和合约地址
        await this.getContractInfo()
        if (this.planID) {
            await this.getPlanDetail()
            await this.getRecordsList()
            await this.calculateReleasePercentage()
        } else {
            this.$refs.ErrorMsg.showErrorMsg('Missing Plan ID')
            setTimeout(() => {
                this.goBack()
            }, 2000)
        }
    },
    methods: {
        // 获取合约ABI和地址
        async getContractInfo() {
            try {
                const res = await getAbi('TokenLocker')
                if (res.code === 0 && res.data) {
                    this.contractAddress = res.data.address
                    this.TokenLockerAbi = res.data.abi
                } else {
                    this.$refs.ErrorMsg.showErrorMsg('Failed to get contract info')
                }
            } catch (err) {
                console.error('Failed to get contract info', err)
                this.$refs.ErrorMsg.showErrorMsg('Failed to get contract info')
            }
        },
        goBack() {
            this.$router.push('/airdropPlan')
        },
        // 获取计划详情
        async getPlanDetail() {
            try {
                this.loading = true
                const res = await getPlanDetail(this.planID)
                console.log('res', res);
                if (res.code === 0 && res.data) {
                    this.planData = res.data
                    // this.planData.unlockFrequency = 1
                    console.log('this.planData', this.planData);
                } else {
                    this.$refs.ErrorMsg.showErrorMsg(res.msg || 'Failed to get plan details')
                }
                this.loading = false
            } catch (err) {
                console.error('Failed to get plan details', err)
                this.$refs.ErrorMsg.showErrorMsg('Failed to get plan details')
                this.loading = false
            }
        },
        // 获取白名单记录列表
        async getRecordsList() {
            this.accountsData = this.planData.accounts
            // try {
            //     this.accountsLoading = true
            //     const res = await getLockedRecords({
            //         page: this.pagination.page,
            //         pageSize: this.pagination.pageSize,
            //         planID: this.planID
            //     })

            //     if (res.code === 0 && res.data) {
            //         this.accountsData = res.data.list || []
            //         this.pagination.total = res.data.total || 0
            //         this.pagination.page = res.data.page || 1
            //         this.pagination.pageSize = res.data.pageSize || 20
            //     } else {
            //         this.$refs.ErrorMsg.showErrorMsg(res.msg || 'Failed to get whitelist records')
            //     }
            //     this.accountsLoading = false
            // } catch (err) {
            //     console.error('Failed to get whitelist records', err)
            //     this.$refs.ErrorMsg.showErrorMsg('Failed to get whitelist records')
            //     this.accountsLoading = false
            // }
        },
        // 计算释放百分比
        async calculateReleasePercentage() {
            try {
                // 确保已获取合约信息
                if (!this.contractAddress || !this.TokenLockerAbi.length) {
                    console.error('合约信息未获取，无法计算释放百分比')
                    return
                }

                // 初始化Web3
                let web3;
                if (window.ethereum) {
                    web3 = new Web3(window.ethereum);
                    // 检查是否连接了MetaMask
                    try {
                        const accounts = await web3.eth.getAccounts();
                        if (accounts.length === 0) {
                            console.log('MetaMask未连接，使用公共节点');
                            web3 = new Web3("https://ethereum-sepolia-rpc.publicnode.com");
                        }
                    } catch (error) {
                        console.log('检查钱包连接失败，使用公共节点', error);
                        web3 = new Web3("https://ethereum-sepolia-rpc.publicnode.com");
                    }
                } else {
                    // 没有MetaMask，使用公共节点
                    console.log('未检测到MetaMask，使用公共节点');
                    web3 = new Web3("https://ethereum-sepolia-rpc.publicnode.com");
                }

                // 创建合约实例
                const contract = new web3.eth.Contract(this.TokenLockerAbi, this.contractAddress);

                const planDetail = await contract.methods.getPlan(this.planID).call();
                console.log('planDetail', planDetail);

                // 调用合约函数获取总锁定量
                const totalLockedAmount = await contract.methods.getTotalLockedAmount().call();

                console.log('totalLockedAmount', totalLockedAmount);

                // 将Wei转换为UNIT
                const totalInUnit = web3.utils.fromWei(totalLockedAmount, 'ether');

                console.log('totalInUnit', totalInUnit);
                console.log('planAmount', this.planData.planAmount);

                // 计算进度百分比：计划释放量/总锁定量
                if (Number(totalInUnit) > 0) {
                    this.releasePercentage = (Number(this.planData.planAmount) / Number(totalInUnit)) * 100;
                    // 确保百分比不是负数且不超过100
                    this.releasePercentage = Math.max(0, Math.min(100, this.releasePercentage));
                    // 四舍五入到两位小数
                    this.releasePercentage = Math.round(this.releasePercentage * 100) / 100;
                }

                console.log('releasePercentage calculated:', this.releasePercentage);
            } catch (err) {
                console.error('计算释放百分比失败:', err);
                // 错误处理，设置默认值
                this.releasePercentage = 0;
            }
        },
        // 格式化ID，只显示前6位和后4位
        formatId(id) {
            if (!id) return ''
            if (id.length <= 10) return id
            return `${id.substring(0, 6)}...${id.substring(id.length - 4)}`
        },
        // 格式化日期
        formatDate(timestamp) {
            if (!timestamp) return '--'
            return moment(timestamp).utc().format('YYYY-MM-DD HH:mm')
        },
        // 格式化中国时间
        formatDateChina(timestamp) {
            if (!timestamp) return '--'
            return moment(timestamp).utcOffset('+08:00').format('YYYY-MM-DD HH:mm')
        },
        // 获取认领方式文本
        getClaimMethodText(method) {
            //0:Direct 1:SelfClaim 领取方式
            const methodMap = {
                0: 'Direct',
                1: 'Self Claim'
            }
            return methodMap[method] || 'Unknown'
        },
        // 获取解锁频率文本
        getUnlockFrequencyText(frequency) {
            const frequencyMap = {
                0: 'Single',
                1: 'Liner'
            }
            return frequencyMap[frequency] || 'Unknown'
        },
        // 获取状态文本
        getStatusText(status) {
            const statusMap = {
                0: 'Ready',
                1: 'In Progress',
                2: 'Completed',
                3: 'Deleted'
            }
            return statusMap[status] || 'Unknown'
        },
        // 获取状态类名
        getStatusClass(status) {
            const statusClassMap = {
                0: 'status-ready',
                1: 'status-in-progress',
                2: 'status-completed',
                3: 'status-deleted'
            }
            return statusClassMap[status] || ''
        },
        // 获取记录状态文本
        getRecordStatusText(status) {
            const statusMap = {
                0: 'Pending Transfer',
                1: 'Transfer Completed',
                2: 'Transfer Failed'
            }
            return statusMap[status] || 'Unknown'
        },
        // 获取记录状态类名
        getRecordStatusClass(status) {
            const statusClassMap = {
                0: 'status-pending',
                1: 'status-completed',
                2: 'status-failed'
            }
            return statusClassMap[status] || ''
        },
        // 计算每次解锁数量
        calculatePerAmount(row) {
            if (!row || !row.times || row.times <= 0) return 0
            // 计算每次解锁数量，然后去除末尾多余的0
            return Number((row.amounts[0] / row.times).toFixed(10)).toString()
        },
        // 获取已认领代币数量
        getClaimedAmount(row) {
            if (!row || !row.amounts || row.amounts.length < 2) return 0
            return row.amounts[0] || 0
        },
        // 获取剩余代币数量
        getRemainingAmount(row) {
            if (!row || !row.amounts || row.amounts.length < 2) return 0
            return row.amounts[1] || 0
        },
        // 分页大小变化
        handleSizeChange(size) {
            this.pagination.pageSize = size
            this.getRecordsList()
        },
        // 页码变化
        handleCurrentChange(page) {
            this.pagination.page = page
            this.getRecordsList()
        },
        // 格式化数字（用于显示）
        formatNumber(num) {
            return parseFloat(num).toLocaleString('en-US', {
                maximumFractionDigits: 2
            });
        }
    }
}
</script>

<style scoped lang="scss">
.detail-header {
    background-color: #fff;
    border-radius: 8px;
    padding: 0.24rem 0.32rem;
    margin-bottom: 0.24rem;

    .detail-title {
        font-size: 0.24rem;
        font-weight: bold;
        margin-bottom: 0.16rem;
    }

    .detail-info {
        .info-item {
            display: flex;
            margin-bottom: 0.16rem;

            .label {
                color: #606266;
                margin-right: 0.14rem;
                // width: 1.5rem;
            }

            .value {
                flex: 1;
                font-weight: 500;
            }
        }
    }
}

.op-btn {
    margin-bottom: 0.24rem;

    .el-button {
        padding: 0.12rem 0.16rem;
        font-size: 0.18rem;
        line-height: 0.2rem;
        color: #626871;
        border-color: #d9dde3;
        background: #fff;
    }
}

.page-table {
    .status-pending {
        color: #E6A23C;
    }

    .status-completed {
        color: #67C23A;
    }

    .status-failed {
        color: #F56C6C;
    }

    .status-in-progress {
        color: #409EFF;
    }

    .status-ready {
        color: #E6A23C;
    }

    .status-deleted {
        color: #F56C6C;
    }
}

.pagination-container {
    padding: 0.2rem;
    text-align: right;

    .el-pagination {
        bottom: 0;
    }
}
</style>